import {TRANSLATION_TYPES} from '../../core/constants/actionTypes';

export const cntrlGetTranslations = payload => ({
  type: TRANSLATION_TYPES.CNTRL_GET_TRANSLATIONS,
  payload
});
